import { render, staticRenderFns } from "./Home-whitelabel.vue?vue&type=template&id=21920d31&scoped=true&"
import script from "./Home-whitelabel.vue?vue&type=script&lang=js&"
export * from "./Home-whitelabel.vue?vue&type=script&lang=js&"
import style0 from "./Home-whitelabel.vue?vue&type=style&index=0&id=21920d31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21920d31",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
